import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { T as Text } from '../../Text/Text-nnmbpLTK.js';

const PageStatus = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-30060407__sc-fxn3rh-0"
})(["display:flex;align-items:center;"]);
PageStatus.displayName = 'PageStatus';
const PaginationPageStatus = ({
  currentPageLabel,
  ...rest
}) => /*#__PURE__*/React__default.createElement(PageStatus, _extends({}, rest, {
  fontSize: "base"
}), currentPageLabel);
PaginationPageStatus.defaultProps = {
  id: undefined
};

export { PaginationPageStatus as P };
//# sourceMappingURL=PaginationPageStatus-BTZ-Lx3C.js.map
